module.exports = __webpack_public_path__ + "ea3c7bb816ccecb1939c05c364357b94.svg";